import { useEffect, useState } from 'react';
import { Button, Heading, Popup, PopupSection } from '@flixbus/honeycomb-react';
import { Icon, IconDownload } from '@flixbus/honeycomb-icons-react';
import { CSVLink } from 'react-csv';
import { useBatchUpdate } from '../../context/VoucherBatchUpdateProvider';
import { Voucher } from '../../types/Voucher';

const DownloadVouchers = () => {
  const [popupActive, setPopupActive] = useState(false);
  const { payload, toggleId } = useBatchUpdate();
  const [triggerDownload, setTriggerDownload] = useState(false);

  const vouchers: Voucher[] = payload.batches[0]?.vouchers || [];
  const vouchersCount = vouchers.length;

  const headers = [{ label: 'Code', key: 'code' }];
  const csvData = vouchers.map(voucher => ({
    code: voucher.code || 'N/A',
  }));

  const clearSelection = () => vouchers.forEach(v => toggleId(v));

  const handleDownload = () => {
    setTriggerDownload(true);
  };

  useEffect(() => {
    if (triggerDownload) {
      const timeout = setTimeout(() => {
        document.getElementById('csv-download-link')?.click();
        setTriggerDownload(false);
        clearSelection();
        setPopupActive(false);
      }, 100);
      return () => clearTimeout(timeout);
    }
  }),
    [triggerDownload];

  return (
    <>
      <Button
        appearance='link'
        onClick={() => setPopupActive(p => !p)}
        disabled={vouchersCount === 0}
      >
        <Icon InlineIcon={IconDownload} />
        Download
      </Button>
      <Popup active={popupActive} onOverlayClick={() => setPopupActive(false)}>
        <PopupSection type='icon'>
          <Icon InlineIcon={IconDownload} size={12} style={{ fill: 'var(--hcr-neutral-color)' }} />
        </PopupSection>
        <PopupSection type='title'>
          <Heading size={2} sectionHeader flushSpace>
            Download voucher(s)?
          </Heading>
        </PopupSection>
        <PopupSection type='content'>
          You are about to download <b>{vouchersCount}</b> vouchers.
        </PopupSection>
        <PopupSection type='actions'>
          <Button onClick={() => setPopupActive(false)}>Go Back</Button>

          <CSVLink
            data={csvData}
            headers={headers}
            filename={`vouchers_${Date.now()}.csv`}
            separator=','
            enclosingCharacter='"'
            id='csv-download-link'
          />

          <Button appearance='primary' onClick={handleDownload}>
            Download CSV
          </Button>
        </PopupSection>
      </Popup>
    </>
  );
};

export default DownloadVouchers;
